import React, { useMemo } from 'react';
import { AiComponentHtmlAttribute } from '@/pkg/ai';
import { StackedInputGroupWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { HtmlAttrLinkInput } from '@/features/editor/widgets/ai-component/inputs/html-attr/html-attr-link-input';
import { HtmlAttrImageInput } from '@/features/editor/widgets/ai-component/inputs/html-attr/html-attr-image-input';
import { conditional } from '@/utils/conditional';

export interface GenericHtmlAttrInputProps {
  component: AiComponentHtmlAttribute;
  setHtmlAttribute: (
    selector: string,
    attribute: AiComponentHtmlAttribute,
    value: string,
  ) => void;
  getHtmlAttribute: (
    selector: string,
    attribute: AiComponentHtmlAttribute,
  ) => string;
}

export function GenericHtmlAttrInput({
  component,
  setHtmlAttribute,
  getHtmlAttribute,
}: GenericHtmlAttrInputProps) {
  const initialValue = useMemo(
    () => getHtmlAttribute(component.selector, component),
    [component, getHtmlAttribute],
  );

  const onChange = (value: string) => {
    setHtmlAttribute(component.selector, component, value);
  };

  return (
    <StackedInputGroupWrapper style={{ padding: 0 }}>
      {conditional(
        null,
        component?.node === `img` && component?.attr === `src`,
        <HtmlAttrImageInput initialValue={initialValue} onChange={onChange} />,
        component?.attr === `href`,
        <HtmlAttrLinkInput initialValue={initialValue} onChange={onChange} />,
      )}
    </StackedInputGroupWrapper>
  );
}
